































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { AdminMenuItem } from '../types';
import { mapState } from 'vuex';

type MenuOrientationV = 'top' | 'bottom';
type MenuOrientationH = 'right' | 'left';
type MenuOrientation = [MenuOrientationV, MenuOrientationH];
interface IMenuOrientationClasses {
  [key: string]: true;
}

@Component({
  computed: mapState('globals', ['user']),
})
export default class AdminMenu extends Vue {
  @Prop({ type: Array, required: true }) private readonly items!: AdminMenuItem[];
  @Prop({ type: Array, default: () => [] }) private readonly badges!: string[];
  @Prop({ type: Boolean, default: false }) private readonly forceDisplay!: boolean;

  // Orientation is based on where you want to put this menu in a container, e.g. if it's going
  // in the top-right corner of a container, use ['top', 'right']
  @Prop({ type: Array, default: () => ['bottom', 'left'] })
  private readonly orientation!: MenuOrientation;

  @Prop({ type: Boolean, default: false }) private readonly includeCreateLessonButton!: boolean;

  private get orientationClasses() {
    return this.orientation.reduce(
      (accumulator: IMenuOrientationClasses, o: MenuOrientationV | MenuOrientationH) => {
        accumulator[o] = true;
        return accumulator;
      },
      {} as IMenuOrientationClasses,
    );
  }
}
